module.exports = __webpack_public_path__ + "img/kyc-dv.908eeb71.svg";